import React, { useEffect } from 'react';
import moment from 'moment';
import cn from 'classnames';
import { useCallback } from 'react';

interface DateRangePresetsProps {
  className?: string;
  value: string;
  onChange: (startDate: Date, endDate: Date, preset: string) => void;
}

const DateRangePresets: React.FC<DateRangePresetsProps> = ({ className, value, onChange }) => {
  useEffect(() => {
    presetSelected(value);
  }, [value]);

  const presetSelected = (preset: string) => {
    let startDate: moment.Moment, endDate: moment.Moment;
    switch (preset) {
      case 'lastmonth':
        startDate = moment().subtract(1, 'months').startOf('month');
        endDate = moment().subtract(1, 'months').endOf('month');
        break;
      case 'lastweek':
        startDate = moment().subtract(1, 'weeks').startOf('week');
        endDate = moment().subtract(1, 'weeks').endOf('week');
        break;
      case 'yesterday':
        startDate = moment().subtract(1, 'days').startOf('day');
        endDate = moment().subtract(1, 'days').endOf('day');
        break;
      case 'today':
        startDate = moment().startOf('day');
        endDate = moment().endOf('day');
        break;
      default:
        return;
    }
    onChange(startDate.toDate(), endDate.toDate(), preset);
  };

  const handlePresetChange = useCallback((preset: string) => {
    presetSelected(preset);
  }, [presetSelected]);

  return (
    <div className={cn('row', className)}>
      <PresetOption
        id="date-range-lm"
        label="Last Month"
        value="lastmonth"
        checked={value === 'lastmonth'}
        onChange={handlePresetChange}
      />
      <PresetOption
        id="date-range-lw"
        label="Last Week"
        value="lastweek"
        checked={value === 'lastweek'}
        onChange={handlePresetChange}
      />
      <PresetOption
        id="date-range-y"
        label="Yesterday"
        value="yesterday"
        checked={value === 'yesterday'}
        onChange={handlePresetChange}
      />
      <PresetOption
        id="date-range-t"
        label="Today"
        value="today"
        checked={value === 'today'}
        onChange={handlePresetChange}
      />
    </div>
  );
};


interface PresetOptionProps {
  id: string;
  label: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
}

const PresetOption: React.FC<PresetOptionProps> = ({ id, label, value, checked, onChange }) => (
  <div className="col-sm-12 col-md-2 col-lg-2 preset-option">
    {/* <label htmlFor={id} className="db-text">&nbsp;</label> */}
    <input
      id={id}
      type="radio"
      name="daterange"
      checked={checked}
      onChange={() => onChange(value)}
      value={value}
      aria-checked={checked}
    /><label htmlFor="option1">{label}</label>
  </div>
);

export default DateRangePresets;